/* Rü theme JS — drawer, search modal, sliders, cart notification */
(function () {
  'use strict';

  /* ---------- Mobile drawer submenus ---------- */
  document.querySelectorAll('[data-drawer-submenu]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var submenu = btn.nextElementSibling;
      if (!submenu) return;
      var open = submenu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* ---------- Search modal ---------- */
  var searchModal = document.getElementById('search-modal');
  document.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!searchModal) return;
      searchModal.classList.add('is-open');
      var input = searchModal.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  });
  document.querySelectorAll('[data-search-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (searchModal) searchModal.classList.remove('is-open');
    });
  });
  if (searchModal) {
    searchModal.addEventListener('click', function (e) {
      if (e.target === searchModal) searchModal.classList.remove('is-open');
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchModal) searchModal.classList.remove('is-open');
  });

  /* ---------- Announcement bar rotation ---------- */
  document.querySelectorAll('.announcement-bar[data-autorotate]').forEach(function (el) {
    var slides = Array.prototype.slice.call(el.querySelectorAll('.slider__slide'));
    if (slides.length < 2) return;
    var index = 0;
    var auto = el.getAttribute('data-autorotate') === 'true';

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.hidden = n !== index;
      });
    }
    var prev = el.querySelector('.slider-button--prev');
    var next = el.querySelector('.slider-button--next');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
    if (auto) setInterval(function () { show(index + 1); }, 5000);
  });

  /* ---------- Featured-collection slider buttons/counter (tablet-down) ---------- */
  document.querySelectorAll('slider-component').forEach(function (component) {
    var slider = component.querySelector('.slider');
    var prev = component.querySelector('.slider-button--prev');
    var next = component.querySelector('.slider-button--next');
    var counter = component.querySelector('.slider-counter--current');
    if (!slider || !prev || !next) return;

    function slideWidth() {
      var first = slider.querySelector('.slider__slide');
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(slider).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function maxScroll() {
      return slider.scrollWidth - slider.clientWidth;
    }
    function update() {
      var atStart = slider.scrollLeft <= 4;
      var atEnd = slider.scrollLeft >= maxScroll() - 4;
      prev.disabled = atStart;
      next.disabled = atEnd;
      if (counter) {
        var total = slider.querySelectorAll('.slider__slide').length;
        var perView = Math.max(1, Math.round(slider.clientWidth / (slideWidth() || 1)));
        var page = Math.min(
          Math.ceil((slider.scrollLeft + 1) / ((slideWidth() || 1) * perView)) || 1,
          Math.ceil(total / perView)
        );
        counter.textContent = page;
      }
    }
    prev.addEventListener('click', function () {
      slider.scrollBy({ left: -slideWidth() * 2, behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      slider.scrollBy({ left: slideWidth() * 2, behavior: 'smooth' });
    });
    slider.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- Cart notification ---------- */
  var notification = document.getElementById('cart-notification');
  document.querySelectorAll('[data-cart-notification-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (notification) notification.classList.remove('active');
    });
  });
})();
